import Select from "react-select";
import type { HandleSelectChange, SelectValues } from "ui-kit/src/MultipleSelect/types";
import { adminSelectBaseProps, adminSelectStyles } from "./adminSelectStyles";

interface AdminMultiSelectComponentProps {
	items?: { value: string; label: string }[];
	placeholder?: string;
	value?: SelectValues | null;
	handleChange: HandleSelectChange;
	isCleareable?: boolean;
	menuPortalTarget?: boolean;
	wideMenu?: boolean;
	isSearchable?: boolean;
	isDisabled?: boolean;
}

/** Admin-only multi select. Same API as ui-kit MultiSelectComponent, admin styling. */
export default function AdminMultiSelectComponent({
	value,
	placeholder,
	items,
	handleChange,
	isCleareable = true,
	menuPortalTarget,
	wideMenu = false,
	isSearchable = true,
	isDisabled = false,
}: AdminMultiSelectComponentProps) {
	const styles = {
		...adminSelectStyles,
		menu: (provided: Record<string, unknown>) => ({
			...(typeof adminSelectStyles.menu === "function" ? adminSelectStyles.menu(provided, {} as never) : provided),
			...(wideMenu
				? {
						minWidth: "max(100%, min(360px, calc(100vw - 32px)))",
					}
				: {}),
		}),
		option: (provided: Record<string, unknown>, state: { isFocused: boolean }) => ({
			...(typeof adminSelectStyles.option === "function" ? adminSelectStyles.option(provided, state as never) : provided),
			...(wideMenu
				? {
						whiteSpace: "normal" as const,
						wordBreak: "break-word" as const,
					}
				: {}),
		}),
		...(wideMenu
			? {
					multiValueLabel: (provided: Record<string, unknown>) => ({
						...provided,
						whiteSpace: "normal" as const,
						wordBreak: "break-word" as const,
					}),
				}
			: {}),
	};

	return (
		<Select
			{...adminSelectBaseProps}
			styles={styles}
			menuPortalTarget={menuPortalTarget ? document.body : adminSelectBaseProps.menuPortalTarget}
			value={value}
			isMulti
			isSearchable={isSearchable}
			isClearable={isCleareable}
			isDisabled={isDisabled}
			onChange={(selected, actionMeta) => {
				handleChange(selected ?? [], actionMeta);
			}}
			closeMenuOnSelect={false}
			placeholder={placeholder}
			options={items}
		/>
	);
}
